/* eslint-disable */
// @ts-nocheck

import { filter } from 'lodash'
import moment from 'moment'
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useMemo, useState } from 'react'

import useServerEcoCycle from '../../../../api/useServerEconomicCycle'
import useServer from '../../../../api/useServerMain'
import useServerOnlineClients from '../../../../api/useServerOnlineClients'
import useServerUsers from '../../../../api/useServerUsers'
import DateInput from '../../../../components/forms/DateInput'
import Input from '../../../../components/forms/Input'
import Select from '../../../../components/forms/Select'
import TextArea from '../../../../components/forms/TextArea'
import Toggle from '../../../../components/forms/Toggle'
import Button from '../../../../components/misc/Button'
import SpinnerLoading from '../../../../components/misc/SpinnerLoading'
import {
  BasicType,
  SelectInterface,
} from '../../../../interfaces/InterfacesLocal'
import { useAppSelector } from '../../../../store/hooks'
import { RegisterContext } from '../AllRegistersList'
import { EditContextBilling } from '../registerDetailsTabs/RegisterDetailsTab'

export const RegisterDetailsStep = () => {
  const { getAllUsersForRedux, isLoading } = useServerUsers()

  const { user } = useAppSelector((store) => store.init)
  const { users } = useAppSelector((store) => store.nomenclator)

  const {
    control,
    setCurrentStep,
    currentStep,
    setValue,
    trigger,
    watch,
    clearErrors,
    isFetching,
    getValues,
    fields,
  } = useContext(RegisterContext)
  const { defaultValues, editMode } = useContext(EditContextBilling)

  useEffect(() => {
    getAllUsersForRedux({
      isActive: true,
      all_data: true,
    })
  }, [])
  const { allowRoles } = useServer()
  const { getMainClientInfo, getClient, client, getAllClients } =
    useServerOnlineClients()
  const { setAllOrderState } = useServerEcoCycle()
  const clientId = watch!('clientId')

  const originsOnline = ['marketplace', 'online', 'shop', 'shopapk']
  const isOrderOnline = originsOnline.includes(defaultValues?.origin!)

  const { areas: allAreas } = useAppSelector((state) => state.nomenclator)
  const areas: SelectInterface[] = useMemo(() => {
    const allSalesAreas = allAreas?.filter((area) => area.type === 'SALE')
    // AREAS FOR ADMINS
    if (allowRoles(['ADMIN'])) {
      const areasForAdmins = allSalesAreas.map((area) => ({
        id: area?.id ?? null,
        name: area?.name ?? '',
      }))
      return areasForAdmins ?? []
      //  AREAS FOR MANAGER AREA
    } else if (
      allowRoles([
        'MANAGER_AREA',
        'MANAGER_SALES',
        'MARKETING_SALES',
        'MANAGER_BILLING',
      ])
    ) {
      const allowedAreasForManagerArea = user?.allowedSalesAreas.map(
        (area) => ({ id: area?.id, name: area?.name })
      )
      const areasForManagerArea = allSalesAreas
        ?.filter((area) =>
          allowedAreasForManagerArea?.find(
            (allowedArea) => allowedArea.id === area.id
          )
        )
        ?.map((area) => ({ id: area?.id ?? null, name: area?.name ?? '' }))
      return areasForManagerArea ?? []
    }
    return []
  }, [])

  useEffect(() => {
    if (clientId) {
      //getAllClients()
      !!getClient && getClient(clientId)
    }
  }, [watch!('clientId')])

  const [filter] = useState<BasicType>({
    clientId: clientId as number,
  })

  useEffect(() => {
    //clientId &&
    //getMainClientInfo!(clientId as number, filter, setAllOrderState); /////////////////////////////////////
  }, [filter, watch!('clientId')])

  //setValue!("managedById", getValues!("clientId"))
  useEffect(() => {
    if (users !== null && users !== undefined) {
      //setValue!("managedById", user?.id);
    }
  }, [watch!('managedById')])

  // const verifiedRoles = ["ADMIN", "MANAGER_SALES", "OWNER", "MANAGER_BILLING", "MARKETING_SALE"]
  const selectManagedData: SelectInterface[] = []

  if (users !== null && users !== undefined) {
    //Select asociated area data ---------------------------------------------------------------------
    users?.map((item) => {
      // users?.filter(user => user?.roles?.find(rol => verifiedRoles.includes(rol.code)))?.map((item) => {
      selectManagedData.push({
        name: `${item.username ?? ''}/ ${item.displayName ?? ''}`,
        id: item.id,
      })
    })

    if (!users.find((userItem) => userItem.id === user?.id)) {
      selectManagedData.push({
        name: `${user?.username ?? ''}/ ${user?.displayName ?? ''}`,
        id: user?.id!,
      })
    }
  }
  let commercialDefaultValue = editMode
    ? defaultValues?.managedBy?.id
    : user?.id
  if (client?.commercial) {
    commercialDefaultValue = client?.commercial?.id
  }

  const paymentsDeadlineSelect: SelectInterface[] = [
    {
      id: 7,
      name: '07 días',
    },
    {
      id: 15,
      name: '15 días',
    },
    {
      id: 30,
      name: '30 días',
    },
    {
      id: 45,
      name: '45 días',
    },
    {
      id: 60,
      name: '60 días',
    },
    {
      id: 'manual',
      name: 'Manual',
    },
  ]

  const timeLimit = watch!('timeLimit')
  const paymentDeadline = watch!('paymentDeadlineAt')
  const name = watch!('name')
  const managedById = watch!('managedById')
  const currencyBilling = watch!('currencyBilling')
  const havePaymentDeadline = watch!('havePaymentDeadline')

  const handlerDueDate = () => {
    if (timeLimit !== 'manual' && timeLimit !== undefined) {
      const date = new Date()
      const newDate = new Date(date.getTime())
      newDate.setDate(newDate.getDate() + timeLimit)
      setValue!('paymentDeadlineAt', newDate)
    }
  }

  const onSubmit = async () => {
    if (
      await trigger!([
        'paymentDeadlineAt',
        'name',
        'managedById',
        'salesBy',
        'currencyBilling',
        'registeredAt',
      ])
    ) {
      // setValue!('registeredAt', registeredAt)
      setValue!('timeLimit', timeLimit)
      setValue!('name', name)
      setValue!('managedById', managedById)
      setValue!('currencyBilling', currencyBilling)
      setValue!('paymentDeadlineAt', paymentDeadline)
      setValue!('havePaymentDeadline', havePaymentDeadline)

      setCurrentStep!(currentStep! + 1)
    }
  }

  useEffect(() => {
    handlerDueDate()
  }, [timeLimit])

  const registeredAt = moment(defaultValues?.registeredAt ?? '').startOf('day')
  const paymentDeadlineAt = moment(
    defaultValues?.paymentDeadlineAt ?? ''
  ).startOf('day')

  const differenceInDays = paymentDeadlineAt?.diff(registeredAt, 'days')

  if (isLoading) {
    return (
      <div className="flex min-h-[25rem] w-full items-center justify-center p-8">
        <SpinnerLoading />
      </div>
    )
  }

  return (
    <div>
      <div className="grid min-h-[25rem] items-center gap-4 px-8">
        {editMode && (
          <Select
            control={control}
            data={areas ?? []}
            defaultValue={
              defaultValues?.areaSales?.id
                ? defaultValues?.areaSales?.id
                : areas.length === 1
                  ? areas[0].id
                  : null
            }
            label={'Punto de venta (*)'}
            name="areaSalesId"
            rules={{ required: 'Este campo es requerido' }}
          />
        )}

        {/* first Row */}
        <div className="grid grid-cols-2 items-center gap-2">
          {/* Titulo */}
          <div className="col-span-2">
            <Input
              control={control}
              defaultValue={editMode ? defaultValues?.name : null}
              label="Título"
              name="name"
            />
          </div>

          {/* Comercial */}
          <div className="col-span-2">
            <Select
              control={control}
              data={selectManagedData}
              defaultValue={commercialDefaultValue}
              disabled={!!client?.commercial?.id}
              label="Comercial que atiende"
              name="managedById"
              rules={{
                required: 'Seleccione un usuario de comercial',
              }}
            />
          </div>
        </div>
        {/* Secound Row */}
        <div className="grid grid-cols-2 items-center gap-2">
          {/* Fecha de emision */}
          <div className="col-span-2">
            <Toggle
              control={control}
              defaultValue={
                typeof defaultValues?.paymentDeadlineAt === 'string' ||
                watch!('havePaymentDeadline')
              }
              name="havePaymentDeadline"
              title="Establecer plazo de pago"
            />
          </div>
          {havePaymentDeadline && (
            <>
              <div>
                <Select
                  control={control}
                  data={paymentsDeadlineSelect}
                  label="Plazo de pago"
                  name="timeLimit"
                  placeholder={
                    defaultValues !== undefined
                      ? `${differenceInDays} días`
                      : 'Seleccione'
                  }
                  rules={{
                    onChange: (e) => {
                      if (e.target.value !== 'manual') {
                        clearErrors!('paymentDeadlineAt')
                      }
                    },
                  }}
                />
              </div>
              <div className="pt-1">
                <DateInput
                  control={control}
                  defaultValue={
                    editMode ? defaultValues?.paymentDeadlineAt : ''
                  }
                  disabled={timeLimit !== 'manual'}
                  fromToday
                  label="Fecha de vencimiento (*)"
                  name="paymentDeadlineAt"
                  rules={{
                    required: 'Este campo es requerido',
                    onChange: (e) => clearErrors!('paymentDeadlineAt'),
                  }}
                />
              </div>
            </>
          )}
        </div>
        <div className="grid">
          <TextArea
            control={control}
            defaultValue={editMode && defaultValues?.observations}
            label="Observaciones"
            name="observations"
          />
        </div>
        {editMode && (
          <div className="">
            <Toggle
              control={control}
              defaultValue={defaultValues?.isPreDispatched}
              name="isPreDispatched"
              title="Predespachado"
            />
          </div>
        )}

        <div className="row-span-2 flex w-full items-end">
          {!editMode ? (
            <div className="grid w-full grid-cols-2 gap-3 pt-2">
              <Button
                action={() => {
                  setCurrentStep!(currentStep! - 1)
                }}
                color="white"
                disabled={currentStep === 0 ? true : false}
                full
                name="Atras"
                outline
                textColor="blue-800"
                type="button"
              />
              <Button
                action={onSubmit}
                color="slate-700"
                full
                name="Continuar"
                type="button"
              />
            </div>
          ) : (
            <div></div>
          )}
        </div>

        {editMode && (
          <div className="row-span-2 flex w-full items-end justify-end">
            <div className="grid">
              <Button
                color="slate-700"
                disabled={isFetching}
                full
                loading={isFetching}
                name={editMode ? 'Actualizar' : `Registrar`}
                type="submit"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
